import { render } from "./Facilities.vue?vue&type=template&id=8420712a&scoped=true"
const script = {}

import "./Facilities.vue?vue&type=style&index=0&id=8420712a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8420712a"

export default script